import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { ProfileStore } from 'pages/settings/pages/personal/pages/account/pages/profile'

type IChangePasswordModalActionsProps = {
  store: ProfileStore
}

export const ChangePasswordModalActions = observer(
  ({ store }: IChangePasswordModalActionsProps) => {
    const { loading, handleChangePasswordSave, onCloseModal } = store

    return (
      <>
        <Button
          text='Cancel'
          onClick={onCloseModal}
          typeBtn={'contained'}
          size={'medium'}
          contained={'secondary'}
        />
        <Button
          text='Save'
          onClick={handleChangePasswordSave}
          disabled={loading}
          loading={loading}
        />
      </>
    )
  }
)
